import React, { useContext, useCallback } from 'react';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FormattedMessage } from 'react-intl';
import { FilterEditorContext } from '../../../../../../components/filter-editor/context';
import { AutomationRulesContext } from '../../../context';
import DropdownItem from './dropdown-item';
import messages from '../messages';
import style from '../style.module.less';

const ExistingFilterSelector = () => {
  const { filterSets } = useContext(FilterEditorContext);
  const { selectedRule, setSelectedRule } = useContext(AutomationRulesContext);
  const filter = (filterSets || {})[selectedRule.filterId];
  const filters = Object.values(filterSets).filter((filt) => filt.active);
  const ishiddenFilter = filter && !filter.active;
  const setToAnActiveFilter = useCallback(
    (filterId) => {
      setSelectedRule({
        ...selectedRule,
        filterId,
      });
    },
    [selectedRule, setSelectedRule],
  );
  return (
    <DropdownMenu className={style['existing-filters']} disabled={!filter || ishiddenFilter}>
      <DropdownMenuToggler className={style['dropdown-toggler']}>
        {filter && !ishiddenFilter && filter.name}
        {(!filter || ishiddenFilter) && <FormattedMessage {...messages.ruleCriteriaSelectFilter} />}
      </DropdownMenuToggler>
      {filters.map((filt) => {
        return (
          <DropdownItem
            key={filt.orderFilterSetId}
            filterId={filt.orderFilterSetId}
            filterName={filt.name}
            onFilterChange={setToAnActiveFilter}
          />
        );
      })}
    </DropdownMenu>
  );
};

export default ExistingFilterSelector;
